// Sidebar.jsx
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import styles from "./Sidebar.module.css";
import { Modal, Button } from "react-bootstrap";
import { LuUsersRound } from "react-icons/lu";
import { TbFileInvoice } from "react-icons/tb";
import DashboardIcon from "../../assets/dashh.svg";
import BeneficiaryIcon from "../../assets/ben.svg";
import HouseoldIcon from "../../assets/houseold.svg";
import RegistrationIcon from "../../assets/registration.svg";
import VerificationIcon from "../../assets/verification.svg";
import DistrictIcon from "../../assets/district.svg";
import ReportIcon from "../../assets/report.svg";
import UserIcon from "../../assets/user.svg";
import SettingsIcon from "../../assets/settings.svg";
import AccountIcon from "../../assets/account.svg";
import LogoutIcon from "../../assets/logout.svg";
import Ologo from "../../assets/social.png";
import axios from "axios";
import { BASE_URL } from "../API/Api";

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [profileCompleted, setProfileCompleted] = useState(false);
  const [openAdmin, setOpenAdmin] = useState(false);
  const [openTenders, setOpenTenders] = useState(false);

  const isActive = (path) => location.pathname.includes(path);

  const [showLogoutModal, setShowLogoutModal] = useState(false);

  const handleLogoutClick = () => {
    setShowLogoutModal(true);
  };

  const handleConfirmLogout = () => {
    // optional: clear tokens
    localStorage.removeItem("userToken");
    localStorage.clear(); // if needed

    setShowLogoutModal(false);
    navigate("/login");
  };

  const handleCancelLogout = () => {
    setShowLogoutModal(false);
  };

  const fetchProgress = async () => {
    try {
      const token = localStorage.getItem("userToken");

      const res = await axios.get(`${BASE_URL}/company/get_progress`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const sections = res.data?.data?.sections || [];

      // ✅ Check if ALL sections are completed
      const allCompleted =
        sections.length > 0 &&
        sections.every((section) => section.progress === 100);

      setProfileCompleted(allCompleted);

    } catch (error) {
      console.log("Progress fetch error:", error);
    }
  };
  useEffect(() => {
    fetchProgress();
  }, []);


  // Add these inside the Sidebar component

  const isAdminSectionActive = () => {
    return (
      openAdmin ||
      location.pathname.includes("/administration_manage_users") ||
      location.pathname.includes("/administration_manage_invoices")
      // add more admin sub-routes here if they appear later
    );
  };

  const isTendersSectionActive = () => {
    return (
      openTenders ||
      location.pathname.includes("/tenders/open") ||
      location.pathname.includes("/tenders/restrict") ||
      location.pathname.includes("/tenders_bidded")
      // add more tender sub-routes here if needed
    );
  };
  const companyApproved = Number(localStorage.getItem("companyApproved"));
  const isLocked = companyApproved === 0;

  return (
    <div className={styles.sidebar}>
      <div className={styles.logoSection}>
        <img src={Ologo} alt="Logo" className={styles.logo} />
      </div>

      <div className={styles.mobilenav}>
       <div className={styles.navSection}>

  {/* MAIN */}
  <p className={styles.sectionTitle}>MAIN</p>

  <button
  className={`${styles.navItem} ${isActive("/dashboard") ? styles.active : ""}`}
  onClick={() => navigate("/dashboard")}
>
  <img src={DashboardIcon} className={styles.icon} alt="" />
  <span>Dashboard</span>
</button>

  <button
  className={`${styles.navItem} ${isActive("/beneficiaries") ? styles.active : ""}`}
  onClick={() => navigate("/beneficiaries")}
>
  <img src={BeneficiaryIcon} className={styles.icon} alt="" />
  <span>Beneficiaries</span>
</button>

<button
  className={`${styles.navItem} ${isActive("/households") ? styles.active : ""}`}
  onClick={() => navigate("/households")}
>
  <img src={HouseoldIcon} className={styles.icon} alt="" />
  <span>Households</span>
</button>

<button
  className={`${styles.navItem} ${isActive("/registrations") ? styles.active : ""}`}
  onClick={() => navigate("/registrations")}
>
  <img src={RegistrationIcon} className={styles.icon} alt="" />
  <span>Registrations</span>
</button>


  {/* MANAGEMENT */}
  <p className={styles.sectionTitle}>MANAGEMENT</p>

 <button
  className={`${styles.navItem} ${isActive("/verifications") ? styles.active : ""}`}
  onClick={() => navigate("/verifications")}
>
  <img src={VerificationIcon} className={styles.icon} alt="" />
  <span>Verifications</span>
</button>

<button
  className={`${styles.navItem} ${isActive("/districts") ? styles.active : ""}`}
  onClick={() => navigate("/districts")}
>
  <img src={DistrictIcon} className={styles.icon} alt="" />
  <span>Districts / Zones</span>
</button>

<button
  className={`${styles.navItem} ${isActive("/reports") ? styles.active : ""}`}
  onClick={() => navigate("/reports")}
>
  <img src={ReportIcon} className={styles.icon} alt="" />
  <span>Reports</span>
</button>

<button
  className={`${styles.navItem} ${isActive("/users") ? styles.active : ""}`}
  onClick={() => navigate("/users")}
>
  <img src={UserIcon} className={styles.icon} alt="" />
  <span>User Management</span>
</button>


  {/* SYSTEM */}
  <p className={styles.sectionTitle}>SYSTEM</p>

  <button
  className={`${styles.navItem} ${isActive("/settings") ? styles.active : ""}`}
  onClick={() => navigate("/settings")}
>
  <img src={SettingsIcon} className={styles.icon} alt="" />
  <span>Settings</span>
</button>

<button
  className={`${styles.navItem} ${isActive("/account") ? styles.active : ""}`}
  onClick={() => navigate("/account")}
>
  <img src={AccountIcon} className={styles.icon} alt="" />
  <span>Account</span>
</button>

<button
  className={styles.navItem}
  onClick={handleLogoutClick}
>
  <img src={LogoutIcon} className={styles.icon} alt="" />
  <span>Logout</span>
</button>

</div>
        <Modal
          show={showLogoutModal}
          onHide={handleCancelLogout}
          centered
          backdrop="static"
        >
          <Modal.Body className={styles.logoutModalBody}>
            <h5 className={styles.logoutTitle}>
              Confirm Logout
            </h5>
            <p className={styles.logoutText}>
              Are you sure you want to logout?
            </p>

            <div className={styles.logoutActions}>
              <Button
                variant="outline-secondary"
                onClick={handleCancelLogout}
              >
                Cancel
              </Button>
              <Button
                variant="danger"
                onClick={handleConfirmLogout}
              >
                Yes, Logout
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </div>
  );
};

export default Sidebar;
